module.exports = __webpack_public_path__ + "img/27_85.315bafc2.png";